import { useEffect, useState } from 'react'

const PAGES = [
  [
    {
      name: 'DICT',
      url: 'https://cms-cdn.e.gov.ph/DICT/uploads/DICT%20COMMERCIAL%20LOGO.png',
    },
    {
      name: 'DICT',
      url: 'https://cms-cdn.e.gov.ph/DICT/uploads/Frame%20289752.png',
    },
  ],
  [
    {
      name: 'DOST',
      url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Department_of_Science_and_Technology_%28DOST%29.svg/1200px-Department_of_Science_and_Technology_%28DOST%29.svg.png',
    },
    {
      name: 'CICC',
      url: 'https://cicc.gov.ph/wp-content/uploads/2023/03/CICC-Logo-Official-1.png',
    },
  ],
]

const INTERVAL_MS = 4000

export function PartnerLogosCarousel() {
  const [page, setPage] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setPage((p) => (p + 1) % PAGES.length)
    }, INTERVAL_MS)
    return () => clearInterval(timer)
  }, [])

  const visible = PAGES[page]

  return (
    <div className="w-full space-y-3">
      <div className="flex items-center justify-center gap-8">
        {visible.map((p) => (
          <div
            key={p.name}
            className="h-[120px] w-[120px] flex items-center justify-center shrink-0"
          >
            <img
              src={p.url}
              alt={p.name}
              className="max-h-full max-w-full object-contain"
              loading="lazy"
            />
          </div>
        ))}
      </div>
      {/* Dots */}
      <div className="flex justify-center gap-1.5">
        {PAGES.map((_, i) => (
          <button
            key={i}
            type="button"
            onClick={() => setPage(i)}
            className={`h-1.5 rounded-full transition-all duration-300 ${
              i === page ? 'w-4 bg-red-500' : 'w-1.5 bg-gray-300'
            }`}
            aria-label={`Page ${i + 1}`}
          />
        ))}
      </div>
    </div>
  )
}
